import moment from 'moment'
import { injuryComplexityKey } from '@/utils/Taxonomy'

export const INJURY_SEVERITIES = [
    { key: 'very_low', rank: 0, color: '#4FA8D8', bg: 'rgba(79,168,216,0.18)', border: 'rgba(79,168,216,0.3)' },
    { key: 'low', rank: 1, color: '#E6AC00', bg: 'rgba(184,134,11,0.18)', border: 'rgba(184,134,11,0.3)' },
    { key: 'medium', rank: 2, color: '#FF6633', bg: 'rgba(204,68,0,0.18)', border: 'rgba(204,68,0,0.3)' },
    { key: 'high', rank: 3, color: '#C23636', bg: 'rgba(194,54,54,0.2)', border: 'rgba(194,54,54,0.32)' },
    { key: 'very_high', rank: 4, color: '#B0455F', bg: 'rgba(122,36,56,0.28)', border: 'rgba(122,36,56,0.4)' },
]

const UNKNOWN_SEVERITY = {
    key: null,
    rank: INJURY_SEVERITIES.length,
    color: 'var(--v-txtMuted-base)',
    bg: 'var(--v-surface2-base)',
    border: 'var(--v-outline-base)',
}

export const injurySeverity = (complexity) => {
    const key = injuryComplexityKey(complexity)
    return INJURY_SEVERITIES.find(severity => severity.key === key) || UNKNOWN_SEVERITY
}

export const injuryDate = (value) => {
    if (!value) return null
    if (typeof value === 'object' && typeof value.toDate === 'function') return moment(value.toDate())
    const date = moment(value, ['YYYY-MM-DD', 'DD-MM-YYYY', moment.ISO_8601], true)
    return date.isValid() ? date : null
}

export const isActiveInjury = (injury) => {
    const discharge = injuryDate(injury?.dischargeDate)
    if (!discharge) return true
    return discharge.isAfter(moment(), 'day')
}
